import React from 'react';
import {connect} from "react-redux";

import UserFieldElement from '../../../reusable/UserFieldElement';
import UserFieldDataType from "../../../../utils/enums/UserFieldDataTypeEnum";

import RaceList from "../common/RaceList";
import UserRoles from "../../../../../../common/src/enums/UserRoles";
import * as AdminActions from "../../../../actions/admin";

class RaceAccounting extends React.Component {
    constructor(props) {
        super(props);
        this.state = Object.assign({
            selectedRaces: [],
            showPigeons: true,
            pigeonhole: 'all',
        });
    }

    componentDidMount() {
        if (this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id) this.props.dispatch(AdminActions.getClub(this.props.auth.currentEntity));
    }

    fields = [];
    render() {
        return <div className={this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? "race-accounting-club" : "race-accounting"}>
            <div className="race-list">
                <RaceList selectedRaces={this.state.selectedRaces} updateSelection={this.updateRaceSelection} filterRaces={race => this.props.auth.currentRole !== UserRoles.SECTION_ADMIN.id || race.Sektion === this.props.auth.currentEntity}/>
            </div>
            <div className="report-options">
                {
                    this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? [
                        <div className="option-group" key="optionsLine1">
                            <span className="option"><input id="showPigeons" name="showPigeons" type="checkbox" checked={this.state.showPigeons} onChange={this.onCheckFieldChange}/><label htmlFor="showPigeons"> Vis duer</label></span>
                        </div>,
                        <div className="option-group" key="optionsLine2">
                            <table><tbody>
                                <tr>
                                    <td>
                                        <label htmlFor="pigeonhole">Slag</label>
                                    </td><td>
                                        <UserFieldElement dataType={UserFieldDataType.enum} placeholder='false' className="field100p" containerClassName="display-inline-block field100p" disabled={this.state.club === ''}
                                                          name="pigeonhole" id="pigeonhole" value={this.state.pigeonhole} options={
                                                                [{key: 'all', value: 'Alle'}].concat(
                                                                this.props.admin.pigeonHoles ? this.props.admin.pigeonHoles.filter(p => p.Foreningsnr === this.props.auth.currentEntity).sort((p1, p2) => p1.Slagnr < p2.Slagnr ? -1 : (p1.Slagnr > p2.Slagnr ? 1 : 0)).map(pigeonHole => (
                                                                    {key: pigeonHole.Slagnr, value: pigeonHole.Slagnr + (pigeonHole.Slagnavn === null ? '' : ' - ' + pigeonHole.Slagnavn)}
                                                                )).toArray() : [])
                                                          }
                                                          autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                                          onChange={this.onStandardFieldChange}
                                                          ref={instance => { this.fields[0] = instance; }}
                                        />
                                    </td>
                                </tr>
                            </tbody></table>
                        </div>
                    ] : null
                }
            </div>
        </div>
    }

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };

    onCheckFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.checked ? true : false});
    };

    allInputValid = () => {
        let result = true;
        this.fields.forEach((field) => {
            if (field && !field.isValid()) result = false;
        });
        return result;
    };

    updateRaceSelection = (races, add = true) => {
        this.setState({
            selectedRaces: add ? this.state.selectedRaces.concat(races.filter(race => this.state.selectedRaces.indexOf(race) < 0)) : this.state.selectedRaces.filter(race => races.indexOf(race) < 0)
        })
    };

    getReportOptions = () => {
        const errors = [];
        if (this.state.selectedRaces.length === 0) errors.push('Der er ikke valgt nogen kapflyvning(er).');
        return {
            errors: errors,
            options: {
                races: this.state.selectedRaces,
                showPigeons: this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? this.state.showPigeons : false,
                pigeonhole: this.state.pigeonhole,
            },
        };
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        pigeonHoles: state.admin.pigeonHoles,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(RaceAccounting);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/subPages/RaceAccounting.js